import React from "react";
import Reveal from "../../components/Reveal";
import RelatioHero from "../../components/cases/RelatioHero";
import CaseArticleRelatio from "../../components/cases/CaseArticleRelatio";
import Footer from "../Footer";
import ContactCta from "../main_page/ContactCta";

export default function RelatioCasePage() {
  return (
    <div className="case-detail-page">
      <Reveal as="section" variant="fade" threshold={0.15}>
        <RelatioHero />
      </Reveal>

      <CaseArticleRelatio/>

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      <Footer />
    </div>
  );
}